import React from "react";
import { useNavigate } from "react-router-dom";

function StoriesDemoPage() {
  const navigate = useNavigate();

  return (
    <div className="stories-page">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Retour
      </button>

      <div className="story-glow glow-one"></div>
      <div className="story-glow glow-two"></div>

      <div className="story-phone">
        <div className="story-ring">
          <div className="story-avatar">EVO</div>
        </div>

        <div className="story-card story-card-1">🌅 Moment</div>
        <div className="story-card story-card-2">🎵 Son tendance</div>
        <div className="story-card story-card-3">⚡ Instant live</div>

        <div className="story-progress">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div className="story-content">
        <p className="story-label">STORIES EVO</p>

        <h1>
          Partage des moments courts, spontanés et visibles en story.
        </h1>

        <p>
          Une expérience rapide, fluide et immersive pour publier des instants,
          suivre les créateurs et faire vivre la communauté EVO-LIVE.
        </p>

        
      </div>

      <style>{`
        .stories-page {
          position: fixed;
          inset: 0;
          overflow: hidden;
          color: white;
          font-family: Arial, sans-serif;
          background:
            radial-gradient(circle at 20% 20%, rgba(0,242,255,0.25), transparent 35%),
            radial-gradient(circle at 85% 75%, rgba(255,0,184,0.28), transparent 35%),
            linear-gradient(135deg, #02040a, #07111f, #02040a);
        }

        .back-btn {
          position: absolute;
          top: 22px;
          left: 22px;
          z-index: 10;
          border: 1px solid #00f2ff;
          background: rgba(0,0,0,0.35);
          color: #00f2ff;
          padding: 10px 16px;
          border-radius: 14px;
          cursor: pointer;
          box-shadow: 0 0 18px rgba(0,242,255,0.4);
        }

        .story-glow {
          position: absolute;
          width: 330px;
          height: 330px;
          border-radius: 50%;
          filter: blur(75px);
          opacity: 0.6;
          animation: floatGlow 5s ease-in-out infinite alternate;
        }

        .glow-one {
          background: #00f2ff;
          top: 8%;
          left: 10%;
        }

        .glow-two {
          background: #ff00b8;
          right: 8%;
          bottom: 8%;
          animation-delay: 1.2s;
        }

        .story-phone {
          position: absolute;
          left: 10%;
          top: 50%;
          transform: translateY(-50%);
          width: 290px;
          height: 560px;
          border-radius: 42px;
          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,255,255,0.18);
          box-shadow:
            0 0 45px rgba(0,242,255,0.35),
            inset 0 0 30px rgba(255,255,255,0.08);
          overflow: hidden;
          animation: phoneIn 0.9s ease forwards;
        }

        .story-phone::before {
          content: "";
          position: absolute;
          top: 13px;
          left: 50%;
          transform: translateX(-50%);
          width: 90px;
          height: 8px;
          border-radius: 20px;
          background: rgba(255,255,255,0.35);
        }

        .story-ring {
          position: absolute;
          top: 70px;
          left: 50%;
          transform: translateX(-50%);
          width: 132px;
          height: 132px;
          border-radius: 50%;
          background: conic-gradient(#00f2ff, #ff00b8, #7b2cff, #00f2ff);
          display: flex;
          align-items: center;
          justify-content: center;
          animation: rotateRing 4s linear infinite;
        }

        .story-avatar {
          width: 106px;
          height: 106px;
          border-radius: 50%;
          background: #02040a;
          border: 4px solid #07111f;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 900;
          color: #00f2ff;
          letter-spacing: 2px;
          animation: avatarPulse 1.8s ease-in-out infinite;
        }

        .story-card {
          position: absolute;
          left: 28px;
          right: 28px;
          height: 82px;
          border-radius: 24px;
          background: rgba(255,255,255,0.11);
          border: 1px solid rgba(255,255,255,0.18);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: 800;
          backdrop-filter: blur(14px);
          box-shadow: 0 0 25px rgba(0,242,255,0.18);
          opacity: 0;
          animation: cardPop 4.5s ease-in-out infinite;
        }

        .story-card-1 {
          bottom: 245px;
        }

        .story-card-2 {
          bottom: 150px;
          animation-delay: 0.5s;
        }

        .story-card-3 {
          bottom: 55px;
          animation-delay: 1s;
        }

        .story-progress {
          position: absolute;
          top: 36px;
          left: 18px;
          right: 18px;
          display: flex;
          gap: 6px;
        }

        .story-progress span {
          height: 4px;
          flex: 1;
          border-radius: 20px;
          background: rgba(255,255,255,0.25);
          overflow: hidden;
          position: relative;
        }

        .story-progress span::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, #00f2ff, #ff00b8);
          transform: translateX(-100%);
          animation: progressLoad 3s linear infinite;
        }

        .story-progress span:nth-child(2)::after {
          animation-delay: 0.4s;
        }

        .story-progress span:nth-child(3)::after {
          animation-delay: 0.8s;
        }

        .story-content {
          position: absolute;
          right: 8%;
          top: 50%;
          transform: translateY(-50%);
          max-width: 560px;
          animation: textIn 1s ease forwards;
        }

        .story-label {
          color: #00f2ff;
          font-weight: 900;
          letter-spacing: 4px;
          margin-bottom: 16px;
        }

        .story-content h1 {
          font-size: 50px;
          line-height: 1.05;
          margin: 0 0 22px;
          background: linear-gradient(90deg, #ffffff, #00f2ff, #ff00b8);
          -webkit-background-clip: text;
          color: transparent;
        }

        .story-content p {
          font-size: 18px;
          line-height: 1.6;
          color: #bdefff;
          margin-bottom: 30px;
        }

        .story-btn {
          border: none;
          background: linear-gradient(90deg, #00f2ff, #0077ff, #ff00b8);
          color: white;
          padding: 15px 28px;
          border-radius: 18px;
          font-size: 17px;
          font-weight: 900;
          cursor: pointer;
          box-shadow: 0 0 30px rgba(0,242,255,0.55);
          animation: btnPulse 1.8s ease-in-out infinite;
        }

        @keyframes rotateRing {
          from { transform: translateX(-50%) rotate(0deg); }
          to { transform: translateX(-50%) rotate(360deg); }
        }

        @keyframes avatarPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.08); }
        }

        @keyframes cardPop {
          0% {
            opacity: 0;
            transform: translateY(40px) scale(0.88);
          }
          25%, 70% {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          100% {
            opacity: 0;
            transform: translateY(-25px) scale(0.96);
          }
        }

        @keyframes progressLoad {
          0% { transform: translateX(-100%); }
          65% { transform: translateX(0); }
          100% { transform: translateX(100%); }
        }

        @keyframes phoneIn {
          from {
            opacity: 0;
            transform: translateY(-50%) translateX(-80px) scale(0.92);
          }
          to {
            opacity: 1;
            transform: translateY(-50%) translateX(0) scale(1);
          }
        }

        @keyframes textIn {
          from {
            opacity: 0;
            transform: translateY(-42%);
          }
          to {
            opacity: 1;
            transform: translateY(-50%);
          }
        }

        @keyframes btnPulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 25px rgba(0,242,255,0.45);
          }
          50% {
            transform: scale(1.06);
            box-shadow: 0 0 45px rgba(255,0,184,0.65);
          }
        }

        @keyframes floatGlow {
          from { transform: translateY(0) scale(1); }
          to { transform: translateY(-35px) scale(1.15); }
        }

        @media (max-width: 850px) {
          .story-phone {
            left: 50%;
            top: 42%;
            transform: translate(-50%, -50%);
            width: 220px;
            height: 430px;
          }

          .story-ring {
            width: 104px;
            height: 104px;
            top: 62px;
          }

          .story-avatar {
            width: 82px;
            height: 82px;
          }

          .story-card {
            height: 64px;
            font-size: 15px;
            left: 20px;
            right: 20px;
          }

          .story-card-1 { bottom: 190px; }
          .story-card-2 { bottom: 115px; }
          .story-card-3 { bottom: 40px; }

          .story-content {
            left: 24px;
            right: 24px;
            top: auto;
            bottom: 30px;
            transform: none;
            text-align: center;
          }

          .story-content h1 {
            font-size: 30px;
          }

          .story-content p {
            font-size: 15px;
          }
        }
      `}</style>
    </div>
  );
}

export default StoriesDemoPage;
